interface TriangleDownProps {
  active?: boolean
}

export function TriangleDown({ active = false }: TriangleDownProps): JSX.Element {
  return (
    <svg
      width="9"
      height="6.5"
      viewBox="0 0 10 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="triangleDown"
    >
      <path d="M5 6.25L1.25 0.75H8.75L5 6.25Z" className={`fill-svgColor ${active ? 'opacity-100' : 'opacity-40'}`} />
    </svg>
  )
}
